import { createFileRoute } from '@tanstack/react-router';
import { PodcastOrCollegeLayout } from '@/components/astro/pages/podcast-or-college-layout';
import { seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/_seo/_legacy/college')({
  head: () => ({
    meta: [
      ...seo({
        title: 'Listen to College Texts',
        description:
          'Explore college-level academic papers and resources on our Listening platform. Enhance your college education with audio content that makes learning flexible and accessible. Start now!',
      }),
    ],
  }),
  component: () => (
    <PodcastOrCollegeLayout
      titleContents={
        <>
          College Students: <br /> Turn{' '}
          <span className='text-azure-455'>Any PDF</span> into
          <br /> An <span className='text-azure-455'>Audiobook</span>
        </>
      }
    />
  ),
});
